import actions from './stagesActions'
import mutations from './stagesMutations'
import state from './stagesState'
import getters from './stagesGetters'

export default {
  namespaced: true,
  getters,
  actions,
  state,
  mutations,
}
